import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'typescript-dotnet-es6/System/Text/Utility'

@Pipe({
  name: 'price'
})
export class PricePipe implements PipeTransform {

  transform(value: any, dynamic?: boolean, ceiling?: number, args?: any): string {
    if(value || (dynamic == true && value === 0)){
      if(typeof(value) == 'number'){
          if (dynamic) {
            if (ceiling==null || ceiling==-1) {
              return format('Dynamic Price BAR - {0}%', new Intl.NumberFormat('en-US',{style: 'decimal',minimumFractionDigits: 0, maximumFractionDigits: 4}).format(value * 100));
            }
            else{
              let n:number = ceiling;
              let s:string = new Intl.NumberFormat('en-US',{style: 'decimal',minimumFractionDigits: 2, maximumFractionDigits: 4}).format(n);
              return format('Dynamic Price - {0}% w/ceiling {1}', new Intl.NumberFormat('en-US',{style: 'decimal',minimumFractionDigits: 0, maximumFractionDigits: 4}).format(value * 100), s);
            }
          } else {
            if (value !== -1) {
              if(ceiling==null){
                let n:number = value;
                let s:string = new Intl.NumberFormat('en-US',{style: 'decimal',minimumFractionDigits: 2, maximumFractionDigits: 4}).format(n);
                return s;// format('{0:###,###,##0.0000}', value);
              }
              else{
                return "Invalid dyn w/ceiling"
              }
            }
            else{
              if(ceiling!=null){
                return "Invalid dyn w/ceiling"
              }
            }


          }
        }
    }
    return '';
  }

}
